<script setup>
import {Link} from "@inertiajs/vue3";
import RouteUserAvatar from "@/Components/documents/route/RouteUserAvatar.vue";

defineProps({
    notification: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <div class="flex gap-5 items-center">
        <RouteUserAvatar
            :users="[notification.data.user]"
            create-link
            size="md" />
        <div class="flex flex-col text-sm">
            <p>
                <component
                    :is="notification.data.user.permissions?.view ? Link : 'span'"
                    :href="route('users.show', notification.data.user.id)"
                    class="font-semibold">
                    {{ notification.data.user.name }} {{ notification.data.user.last_name }}
                </component>
                завершил(-а) регистрацию по вашему приглашению.
            </p>
            <p class="text-accent-blue flex gap-2 items-center">
                <span>{{ notification.created_at }}</span>
            </p>
        </div>
    </div>
</template>
